module.exports = __webpack_public_path__ + "img/kjicon2.3112f6f1.svg";